import React from 'react';
import style from './index.scss';

export default ({ className = '', setRef, children }) =>
    <div ref={setRef} className={`${style.fadeIn} ${className}`}>{children}</div>;
